module.exports = __webpack_public_path__ + "static/fipcballmouse1-45de3e65a64865fe55ffae1e71bec269.jpeg";